import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import TheWayconIdentity from "./sections/TheWayconIdentity";
import CorePhilosophies from "./sections/CorePhilosophies";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <TheWayconIdentity />
      <CorePhilosophies />
      <Footer />
    </div>;
}